import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const ImpersonateIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        d="M5 4a1 1 0 0 0-1 1v2a1 1 0 0 1-2 0V5a3 3 0 0 1 3-3h2a1 1 0 0 1 0 2H5Zm11-1a1 1 0 0 1 1-1h2a3 3 0 0 1 3 3v2a1 1 0 1 1-2 0V5a1 1 0 0 0-1-1h-2a1 1 0 0 1-1-1Zm5 13a1 1 0 0 1 1 1v2a3 3 0 0 1-3 3h-2a1 1 0 1 1 0-2h2a1 1 0 0 0 1-1v-2a1 1 0 0 1 1-1ZM3 16a1 1 0 0 1 1 1v2a1 1 0 0 0 1 1h2a1 1 0 1 1 0 2H5a3 3 0 0 1-3-3v-2a1 1 0 0 1 1-1Zm7-4a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z"
        clipRule="evenodd"
      />
      <path
        fillRule="evenodd"
        d="M7.3 7.4a8.5 8.5 0 0 1 12.6 4 2 2 0 0 1 0 1.3 8.5 8.5 0 0 1-15.8 0 2 2 0 0 1 0-1.4 8.5 8.5 0 0 1 3.2-3.9ZM12 8a6.5 6.5 0 0 0-6 4 6.5 6.5 0 0 0 12 0 6.5 6.5 0 0 0-6-4Z"
        clipRule="evenodd"
      />
    </Icon>
  )
);
export default ImpersonateIcon;
